var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 352 248",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "t",
    x: 0,
    y: 0,
    width: 352,
    height: 248,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 352 0)",
    width: 352,
    height: 248,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.76 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.23 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.69 248h-18.516v-248l18.516-1.5422e-6v248z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.17 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.638 248h-18.517v-248l18.517-1.5422e-6 1e-4 248z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.105 248h-18.517v-248l18.517-1.5422e-6 1e-4 248z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.569 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.052 248h-18.517l-1e-4 -248 18.517-1.5422e-6v248z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.517 248h-18.517l-2.2757e-5 -248 18.517-1.5422e-6 1e-4 248z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.26 248h-18.517v-248l18.517-1.543e-6v248z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.77 248h-18.516v-248l18.516-1.5422e-6v248z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.29 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.83 248h-18.516v-248l18.516-1.5422e-6v248z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.36 248h-18.516v-248l18.516-1.5422e-6v248z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.88 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.41 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.95 248h-18.516v-248l18.516-1.5422e-6v248z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.47 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 248h-18.517v-248l18.517-1.5422e-6v248z",
    fill: "url(#j)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 157.5,
    x2: 157.5,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0001C8",
    offset: 0.0013992
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0332D0",
    offset: 0.07374
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065DD6",
    offset: 0.1495
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0984DC",
    offset: 0.2313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA4E1",
    offset: 0.3181
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBEE5",
    offset: 0.4112
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED3E8",
    offset: 0.5131
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FE1EA",
    offset: 0.6282
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E9EC",
    offset: 0.7679
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 138.96,
    x2: 138.96,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0112CB",
    offset: 0.032376
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0545D2",
    offset: 0.1328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871D9",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A97DF",
    offset: 0.3462
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CB6E4",
    offset: 0.4579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECEE7",
    offset: 0.5744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDFEA",
    offset: 0.6976
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E9EC",
    offset: 0.8323
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 120.44,
    x2: 120.44,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0221CD",
    offset: 0.074172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0656D5",
    offset: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0984DC",
    offset: 0.3441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BAAE2",
    offset: 0.4789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC7E6",
    offset: 0.6125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBE9",
    offset: 0.7447
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E8EB",
    offset: 0.8747
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 101.9,
    x2: 101.9,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032ACE",
    offset: 0.1143
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0764D7",
    offset: 0.2907
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A95DF",
    offset: 0.4614
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBBE4",
    offset: 0.6219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED6E9",
    offset: 0.7696
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E6EB",
    offset: 0.9003
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 83.375,
    x2: 83.375,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0326CE",
    offset: 0.1215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076CD8",
    offset: 0.3616
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA3E1",
    offset: 0.5782
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECBE7",
    offset: 0.7635
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FE3EB",
    offset: 0.9101
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 64.847,
    x2: 64.847,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065CD6",
    offset: 0.3461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA9E2",
    offset: 0.6641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD9E9",
    offset: 0.8887
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 46.317,
    x2: 46.317,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 27.786,
    x2: 27.786,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0109C9",
    offset: 0.089858
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0221CD",
    offset: 0.2365
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0549D3",
    offset: 0.4218
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0980DC",
    offset: 0.6384
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC6E6",
    offset: 0.8785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 9.2567,
    x2: 9.2567,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0004C9",
    offset: 0.1253
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0111CB",
    offset: 0.2553
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0325CE",
    offset: 0.3875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0542D2",
    offset: 0.5211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0768D8",
    offset: 0.6559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A96DF",
    offset: 0.7917
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECBE7",
    offset: 0.9258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 176.01,
    x2: 176.01,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021DCC",
    offset: 0.029907
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0548D3",
    offset: 0.081428
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#086FD9",
    offset: 0.1386
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A91DE",
    offset: 0.2003
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CAEE2",
    offset: 0.2677
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC5E6",
    offset: 0.3427
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD6E9",
    offset: 0.4287
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FE3EB",
    offset: 0.5324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10EAEC",
    offset: 0.6718
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 194.51,
    x2: 194.5,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0001C8",
    offset: 0.0013992
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0332D0",
    offset: 0.07374
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065DD6",
    offset: 0.1495
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0984DC",
    offset: 0.2313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA4E1",
    offset: 0.3181
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBEE5",
    offset: 0.4112
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED3E8",
    offset: 0.5131
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FE1EA",
    offset: 0.6282
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E9EC",
    offset: 0.7679
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 213.04,
    x2: 213.04,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0112CB",
    offset: 0.032376
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0545D2",
    offset: 0.1328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871D9",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A97DF",
    offset: 0.3462
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CB6E4",
    offset: 0.4579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECEE7",
    offset: 0.5744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDFEA",
    offset: 0.6976
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E9EC",
    offset: 0.8323
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 231.57,
    x2: 231.57,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0221CD",
    offset: 0.074172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0656D5",
    offset: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0984DC",
    offset: 0.3441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BAAE2",
    offset: 0.4789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC7E6",
    offset: 0.6125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBE9",
    offset: 0.7447
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E8EB",
    offset: 0.8747
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 250.1,
    x2: 250.1,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032ACE",
    offset: 0.1143
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0764D7",
    offset: 0.2907
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A95DF",
    offset: 0.4614
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DBBE4",
    offset: 0.6219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED6E9",
    offset: 0.7696
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E6EB",
    offset: 0.9003
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 268.62,
    x2: 268.62,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0326CE",
    offset: 0.1215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076CD8",
    offset: 0.3616
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA3E1",
    offset: 0.5782
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECBE7",
    offset: 0.7635
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FE3EB",
    offset: 0.9101
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 287.15,
    x2: 287.15,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065CD6",
    offset: 0.3461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA9E2",
    offset: 0.6641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD9E9",
    offset: 0.8887
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 305.68,
    x2: 305.68,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 324.22,
    x2: 324.22,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0109C9",
    offset: 0.089858
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0221CD",
    offset: 0.2365
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0549D3",
    offset: 0.4218
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0980DC",
    offset: 0.6384
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC6E6",
    offset: 0.8785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 342.74,
    x2: 342.74,
    y1: 236.92,
    y2: 8.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0004C9",
    offset: 0.1253
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0111CB",
    offset: 0.2553
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0325CE",
    offset: 0.3875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0542D2",
    offset: 0.5211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0768D8",
    offset: 0.6559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A96DF",
    offset: 0.7917
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECBE7",
    offset: 0.9258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 -8.3289e-8 -9.1762e-8 -1 0 248)",
    width: 352,
    height: 248,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif);
export default __webpack_public_path__ + "static/media/motif.ebbc01250e5d2f5b59589793986b43c8.svg";
export { ForwardRef as ReactComponent };